// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
  selector: 'e-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
})
export class DropdownComponent {
  @Input() isActive: boolean;
  @Output() isActiveChange = new EventEmitter<boolean>();

  constructor(private eRef: ElementRef) {
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.isActive && !this.eRef.nativeElement.contains(event.target)) {
      this.isActiveChange.emit(false);
    }
  }
}
